export const FEED_PREVIEW_PARAM = "feedPreview"
export const FEED_PREVIEW_COOKIE = "feed-preview"
// Which saved audience array a draft preview shows. Only meaningful next to a signed
// token: the backend ignores it on public reads, so it never becomes a shopper filter.
export const FEED_PREVIEW_SEGMENT_PARAM = "feedPreviewSegment"

export const STUDIO_MOCK_PARAM = "studioMock"
export const STUDIO_MOCK_COOKIE = "studio-mock"

// A real backend preview token is a signed "<payload>.<sig>" string used to fetch
// unpublished drafts. A bare flag like "1" only flips the gate on — sending it to the
// feed API would 404, so it resolves to undefined and the LIVE (published) feed is served.
export const feedPreviewToken = (preview?: string): string | undefined => (preview?.includes(".") ? preview : undefined)
